import { TUTORIAL_STOP, TUTORIAL_GO, TUTORIAL_STEP } from "redux/actions/types";

const initialState = {
    step: 0,
    run: true,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case TUTORIAL_STEP:
            return {
                ...state,
                step: action.payload < 0 ? 0 : action.payload,
            };

        case TUTORIAL_GO:
            return {
                ...state,
                run: true,
            };

        case TUTORIAL_STOP:
            return {
                ...state,
                run: false,
            };

        default:
            return state;
    }
};
